// import React from 'react';
import { switchGlobalMode, appendEmptyControlNet, changeControlNetType } from '@starflow/app/modules/generator/helpers';
import { notifyError } from '@shakkerai/pro-components';
import { getTempState, setTempState } from '@starflow/app/store';
import { requestImageGroupInfo, requestTaskDetail, requestTaskProjectData } from '@shakkerai/services';
import { requestModelVersionDetail } from '@shakkerai/services';
import { applyModel } from '@starflow/app/modules/models/helpers';
import { openReferGenerationParamsModal } from '@shakkerai/pro-panel/src/components/ReferParams';
import { openReferRemixModal, applyPicRemix } from '@shakkerai/pro-panel/src/components/ReferRemix';
import { getActiveGeneratorNodeId } from '@starflow/app/helpers/flow';
import { getSearchParams } from '@shakkerai/utils';

export * from '@starflow/app/modules/models/helpers';

export const tryApplyReferenceModel = async () => {
  const search = new URLSearchParams(location.search);
  const modelVersionUuid = search.get('version');
  const controlnet = search.get('controlnet');

  if (modelVersionUuid) {
    const res = await requestModelVersionDetail(modelVersionUuid);

    if (res?.code !== 401 && res?.code !== 1100000101) {
      setTimeout(() => {
        const projectId = getSearchParams('projectId');
        const replaceUrl = `${location.origin + location.pathname}?projectId=${projectId}`;
        history.replaceState(null, null, replaceUrl);
      }, 1000);
    }

    const modelVersionData = res?.data;

    if (modelVersionData) {
      const isSimpleMode = getTempState('globalMode') === 'simple';

      if (isSimpleMode) {
        switchGlobalMode('pro');
      }

      const appliedModel = {
        name: modelVersionData.name,
        uuid: modelVersionData.uuid,
        versionId: modelVersionData.versionId,
        baseType: modelVersionData.baseType,
        modelType: modelVersionData.modelType,
        imageUrl: modelVersionData.images?.[0]?.imageUrl,
        modelId: modelVersionData.modelId,
        modelUuid: modelVersionData.modelUuid,
        modelName: modelVersionData.name,
        vipUsed: modelVersionData.vipUsed,
      };

      const isLoraModel = appliedModel.modelType?.toLowerCase() === 'lora';

      if (!appliedModel.baseType || !appliedModel.modelType) {
        notifyError('Unsupported model type~');
        return;
      }

      setTimeout(() => {
        const unitId = getActiveGeneratorNodeId();
        if (unitId) {
          applyModel(appliedModel, unitId, true);
          setTempState({ [isLoraModel ? 'showLoraAddedTip' : 'showCheckpointAddedTip']: true });
        }
      }, 2000);
    }
  }

  if (controlnet) {
    setTimeout(async () => {
      try {
        const unitId = getActiveGeneratorNodeId();

        if (unitId) {
          const controlNetId = await appendEmptyControlNet(unitId);
          changeControlNetType(unitId, controlNetId, controlnet);
          setTempState('exclusiveWindow', `controlnet-options-${controlNetId}`);
        }
      } catch (e) {
        console.log(e);
      }
    }, 100);
  }
};

// ?group=3759f9ab231546fba57156f2532f0712&image=8e0f9401e5f74797931713269a699457
export const tryApplyReferenceGenerationInfo = async () => {
  const search = new URLSearchParams(location.search);
  const imageGroupUuid = search.get('group');
  const imageUuid = search.get('image');
  const contentId = search.get('contentId');

  if (contentId && contentId !== '0' && contentId !== 'null') {
    // 兼容pic的画同款写法
    const taskInfo = await requestTaskProjectData(contentId).then((res) => res.data);

    if (taskInfo) {
      const { generateId } = taskInfo;
      let imageUrl = null;

      try {
        const taskDetail = await requestTaskDetail({ generateId }).then((res) => res.data);
        console.log(`[DEBUG] taskDetail`, taskDetail);
        imageUrl = taskDetail.images?.[0].imageId;
      } catch {
        // ...
      }

      setTimeout(() => {
        const projectId = getSearchParams('projectId');
        const replaceUrl = `${location.origin + location.pathname}?projectId=${projectId}`;
        history.replaceState(null, null, replaceUrl);
        applyPicRemix(taskInfo.projectData, imageUrl);
      }, 1000);
    }
  } else if (imageGroupUuid && imageUuid) {
    const res = await requestImageGroupInfo(imageGroupUuid);

    if (res?.code !== 401 && res?.code !== 1100000101) {
      setTimeout(() => {
        const projectId = getSearchParams('projectId');
        const replaceUrl = `${location.origin + location.pathname}?projectId=${projectId}`;
        history.replaceState(null, null, replaceUrl);
      }, 1000);
    }

    const groupInfo = res?.data;

    const matchedImage = groupInfo?.images?.find((item) => item.uuid === imageUuid);

    if (matchedImage) {
      // 弹出参数一键填充对话框
      openReferGenerationParamsModal(matchedImage);
    }
  }
};

// ?action=remix&generateId=123&imageId=312
export const tryApplyRemixInfo = async () => {
  const search = new URLSearchParams(location.search);
  const action = search.get('action');
  const generateId = search.get('generateId');
  const imageId = search.get('imageId');

  if (action === 'remix' && generateId) {
    const taskInfo = await requestTaskDetail({ generateId }).then((res) => res.data);

    if (taskInfo) {
      openReferRemixModal(taskInfo, imageId);
    }
  }
};
